import request from './request';
/**
 * 获取意见反馈问题类型
 */
export function getFeedbackType() {
    return request('/feedback/type', {
        method: 'GET',
    });
}

/**
 * 提交问题
 */
export function feedbackSubmit(params) {
    return request('/feedback/submit', {
        method: 'POST',
        params,
    });
}

/**
 * 获取我的反馈记录
 */
export function getFeedbackRecord(params) {
    return request('/feedback/myself', {
        method: 'GET',
        params,
    });
}
